import * as React from 'react';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import DealPage from "../../../pages/deal";
import SubjectPage from "../../../pages/subjectPage";
import SignPage from "../../../pages/signPage";
import OAuthPage, {OAuthError} from "../../../pages/oauthPage";
import AckAccess from "../../../pages/ackAccess";
import MainPage from "../../../pages/main";
import PaymentsPage from "../../../pages/paymentsPage";
import ClientsPage from "../../../pages/clientsPage";
import {CustomThemeProvider} from "./ThemeContext";
import DealListPage from "../../../pages/deals";
import {NotifyProvider} from "./AlertNotify";

export default function App() {
  return (
    <CustomThemeProvider>
      <NotifyProvider>
        <Router>
          <Routes>
            <Route path="" element={<DealListPage/>}/>
            <Route path="/main" element={<MainPage/>}/>
            <Route path="/deal" element={<DealPage/>}/>
            <Route path="/clients" element={<ClientsPage/>}/>
            <Route path="/subject" element={<SubjectPage/>}/>
            <Route path="/sign" element={<SignPage/>}/>
            <Route path="/payments" element={<PaymentsPage/>}/>
            <Route path="/oauth/callback" element={<OAuthPage/>}/>
            <Route path="/oauth/error" element={<OAuthError/>}/>
            <Route path="/ackaccess" element={<AckAccess/>}/>
          </Routes>
        </Router>
      </NotifyProvider>
    </CustomThemeProvider>
  );
}